import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CreateTutorComponent } from "./create-tutor.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { ToastrModule } from "ng6-toastr-notifications";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";
import { NgxSmartModalModule } from "ngx-smart-modal";

@NgModule({
  declarations: [CreateTutorComponent],
  imports: [
    CommonModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      backdropBorderRadius: "3px",
    }),
    ReactiveFormsModule,
    NgxSmartModalModule,
    ToastrModule,
    NgSelectModule,
  ],
})
export class CreateTutorModule {}
